<app-navbar></app-navbar>

<ng-container *ngIf="isLinkExpired; else notExpired">
  <div class="page">
    <div class="confirmation-container">
      <mat-icon class="text-danger icon-large">error_outline</mat-icon>
      <h2>{{ 'Link Expired' | translate }}</h2>
      <p>{{ 'Sorry, this link is no longer valid. Please request a new quote.' | translate }}</p>
      <button class="dashboard-btn" (click)="toDashboard()">{{ 'Return to Home' | translate }}</button>
    </div>
  </div>
</ng-container>

<ng-template #notExpired>
  <ng-container *ngIf="wentWrong; else successBlock">
    <div class="page">
      <div class="confirmation-container">
        <mat-icon [class.text-danger]="!alreadyVerified" [class.text-warning]="alreadyVerified"
                  class="  icon-large">{{!alreadyVerified ? 'error_outline' :
          'warning'}}</mat-icon>
        <h2>{{ errorMessage | translate }}</h2>
        <p *ngIf="alreadyVerified">{{ 'Your request has already been confirmed.' | translate }}</p>
        <p *ngIf="alreadyVerified==false">{{ 'Something went wrong. Please request a new quote.' | translate }}</p>
        <button class="dashboard-btn" (click)="toDashboard()">
          {{ 'Return to Home' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #successBlock>
  <div class="page">
    <div class="confirmation-container">
      <mat-icon class="color-primary icon-large">
        check_circle_outline
      </mat-icon>
      <h2>{{'Request Received!' | translate}}</h2>
      <p>{{'Thank you for confirming your email. Your request has been successfully received by the clinic and you will
        be contacted shortly.' | translate}}</p>
      <button class="dashboard-btn" (click)="toDashboard()">{{'Return to Home' | translate}}</button>
    </div>
  </div>
</ng-template>
